import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const CheckoutConfirmed = props => {
  const { orderID, orderEmail } = props;
  return (
    <div className="checkout__confirmed">
      <FontAwesomeIcon icon={faCheckCircle} />
      <h2>Your Order is Confirmed</h2>
      <p>
        {`Thank you for your purchase. Your order number is `}
        <b className="d-inline-block">{orderID}</b>
        {`. `}
      </p>
      <p>
        We&apos;re working on setting up your course(s). This may take 10-15
        minutes.
      </p>
      <p>
        {`When your course is ready an email will be sent to `}
        <b className="d-inline-block">{orderEmail}</b>
        {` with more information about how to access your
        course(s). Please keep this email for your records. If
        you have any questions, `}
        <span className="d-inline-block">
          {`please `}
          <Link to="/contact-us">contact us</Link>
          {`. `}
        </span>
      </p>
    </div>
  );
};

CheckoutConfirmed.propTypes = {
  orderID: PropTypes.string.isRequired,
  orderEmail: PropTypes.string.isRequired
};

export default CheckoutConfirmed;
